export default __webpack_public_path__ + "static/Logo-Ether-bee63387c95c9f438abb0ee1951ee859.png";